/**
 * Copyright 2026 Salesforce, Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
import { useSite } from '@salesforce/storefront-next-runtime/site-context';

/**
 * Returns the active currency code for the current session (e.g. "USD", "GBP").
 * Derived from the site context, which resolves the currency from the locale's
 * preferredCurrency, a currency cookie, or the site's default.
 */
export function useCurrency(): string {
    const { currency } = useSite();
    return currency;
}
